import { h } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import clsx from 'clsx';
import Price from './product-price';
import Image from '../utils/image';

const AddToCartSticky = ({
  currentProduct,
  currentVariant,
  children,
  atcRef,
}) => {
  const [isStickyActive, setIsStickyActive] = useState(false);
  const { body } = document;
  const headerDom = document.querySelector('[data-section="header"]');

  const scrollHandler = () => {
    const buttonOffsetTop = atcRef.current?.offsetTop;
    const stickyStart =
      window.pageYOffset +
      ((headerDom?.offsetHeight || 133) -
        (atcRef?.current?.offsetHeight || 45));

    if (buttonOffsetTop && stickyStart >= buttonOffsetTop) {
      setIsStickyActive(true);
      body.classList.add('sticky-buttons-scrolled');
    } else {
      setIsStickyActive(false);
      body.classList.remove('sticky-buttons-scrolled');
    }
  };

  let animationFrameId = null;

  const throttledScrollHandler = () => {
    if (animationFrameId) {
      cancelAnimationFrame(animationFrameId);
    }

    animationFrameId = requestAnimationFrame(scrollHandler);
  };

  useEffect(() => {
    scrollHandler();
    window.addEventListener('scroll', throttledScrollHandler);

    return () => {
      window.removeEventListener('scroll', throttledScrollHandler);
      cancelAnimationFrame(animationFrameId);
    };
  }, []);

  return (
    <div
      id="sticky-atc-buttons"
      className={clsx(
        'top-0 transition-transform ease-in duration-200  h-auto',
        'left-0 w-full px-[10px] laptop:py-0 flex justify-between z-[30] bg-neutral',
        'items-center laptop:px-10 overflow-hidden fixed laptop:min-h-[90px]',
        'laptop:py-3 border-b border-black-30 pt-[11px] pb-[12px]',
        isStickyActive ? 'translate-y-0' : '-translate-y-full',
      )}
    >
      <div className="gap-4 items-center justify-start hidden laptop:flex">
        <div className="max-w-[77px]">
          <Image
            src={currentVariant?.image?.url}
            srcWidths={{ sm: 640, md: 768, lg: 1024, xl: 1280, '2xl': 1536 }}
          />
        </div>
        <div>
          <p className="font-16 flex-1 text-black-2 mb-0.5">
            {currentProduct?.title}
          </p>
          <Price
            currentPrice={currentVariant?.price}
            currentComparePrice={currentVariant?.compareAtPrice}
            fontClass={'font-14 text-black-2'}
            customContainerClass={''}
          />
        </div>
      </div>

      <div className="sticky-atc-buttons w-full laptop:w-auto">{children}</div>
    </div>
  );
};

export default AddToCartSticky;
